import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileBookingBar from "@/components/MobileBookingBar";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="min-h-screen bg-[#0A0A0C]">
      <Navbar />
      <main className="pt-[70px] pb-20 lg:pb-0">{children}</main>
      <Footer />
      <MobileBookingBar />
    </div>
  );
}
